/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable-next-line array-callback-return */
import Form from "./Form";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import FormSkeleton from "../../Components/Skeleton/FormSkeleton";
import { LoadResourceAction, ShowResourceAction, UpdateResourceAction } from './../../Redux/Actions/CrudActions';

const TeamsEdit = ({ ID }) => {

    const ACTION_TYPE = "COMMON";

    const BACKEND_ROUTE = "locations";

    const SubmitButtonName = 'Update Location';
    
    var fields = {
        name: '',
        status: '',
    }

    const dispatch = useDispatch();

    const [data, setData] = useState(fields);

    const [errors, setErrors] = useState(fields);

    const state = useSelector(state => state.common);

    const [refreshTable, setRefreshTable] = useState(false);

    useEffect(() => {
        dispatch({ type: `RESTART_${ACTION_TYPE}_FORM` });
        dispatch(ShowResourceAction(BACKEND_ROUTE, ID, ACTION_TYPE));
    }, []);

    useEffect(() => {
        if (refreshTable) {
            dispatch(LoadResourceAction(BACKEND_ROUTE, ACTION_TYPE));
            setRefreshTable(false);
        };
    }, [refreshTable]);

    useEffect(() => {
        if (state.form.errors && state.form.errors.validation_errors) {
            const errors = state.form.errors.validation_errors;
            for (let error in errors) {
                var key = error;
                var value = errors[key][0];
                setErrors({ ...errors, [key]: value });
            }
            dispatch({ type: `RESTART_${ACTION_TYPE}_FORM` });
        }

        if (state.form.success) {
            setErrors(fields);
            dispatch(LoadResourceAction(BACKEND_ROUTE, ACTION_TYPE));
        }

        if (state.show.success && state.show.payload) {
            setData({
                _method: "PUT",
                name: state.show.payload.data.name,
                status: state.show.payload.data.status
            });
        }
    }, [state]);


    function handleSubmit(e) {
        e.preventDefault();
        // Call Redux Action to update the resouce
        dispatch(UpdateResourceAction(BACKEND_ROUTE, ID, data, ACTION_TYPE));
    }

    return (
        <div>
            { state.show.loading ?
                <FormSkeleton />
                :
                <Form
                    btnloading={state.form.loading}
                    handleSubmit={handleSubmit}
                    data={data}
                    setData={setData}
                    SubmitButtonName={SubmitButtonName}
                    errors={errors}
                />
            }
        </div>
    );
}

export default TeamsEdit;